import { FC } from 'react';
import { Typography, TypographyProps, Box } from '@mui/material';

/**
 * @summary Кастомный компонент для подсказки, которая расположена вверху модуля как пояснительный текст.
 */

export const ModuleNote: FC<TypographyProps> = (props) => {
  return (
    <Box my={1}>
      <Typography variant="subtitle2" {...props}>
        {props.children}
      </Typography>
    </Box>
  );
};
